// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"f4c7776c","279":"f4c7776c","535":"84a7ab96"}[chunkId] + ".chunk.css";
};